import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { site } from "../content";
import { trackEvent } from "../lib/analytics";
import { Reveal, SectionHeading } from "./Reveal";

export default function Faq() {
  const handleChange = (value) => {
    if (value) {
      const item = site.faq[Number(value)];
      trackEvent("faq_open", {
        faq_question: item?.q,
        page_path: window.location.pathname,
      });
    }
  };

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-4xl px-6 md:px-12">
        <SectionHeading
          chapter="16"
          eyebrow="Dúvidas frequentes"
          title="Perguntas e respostas"
          align="center"
          testId="faq-heading"
        />

        <Reveal delay={0.15}>
          <Accordion
            type="single"
            collapsible
            onValueChange={handleChange}
            className="mt-14 space-y-4"
            data-testid="faq-accordion"
          >
            {site.faq.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={String(i)}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-2xl border border-white/10 bg-graphite/60 px-6 backdrop-blur-xl transition-[border-color] duration-300 data-[state=open]:border-gold/35 md:px-8"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-sm font-bold uppercase tracking-wide text-bone hover:text-gold hover:no-underline md:text-base [&[data-state=open]>svg]:text-gold"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-bone/60 md:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
